import { memo } from 'react'

import PromptCarousel, { TEST_ID } from './PromptCarousel'

const PromptCarouselComponent = memo(PromptCarousel)

export { TEST_ID }

export default PromptCarouselComponent
